import { createApp, createSSRApp } from "vue"
import App from "./App.vue"
import { createRouter } from "./router"
import { createPinia } from "pinia"
import { createHead } from "@unhead/vue/client"
import firebaseFuctionInit, { firebaseUtils } from "@/utils/analytic/firebaseUtils.js"
import vue3GoogleLogin from "vue3-google-login"
import fc from "@/components/functionComp/index"
import "@/assets/css/css.js"
import useUserDataStore from "@/store/userDataStore"
import * as Sentry from "@sentry/vue"
import tools, { isDev, isMobileDevice, hasLangPrefix } from "@/utils/tools.js"
import { createI18nInstance, registerI18n, LanguageList } from "./i18n/i18n.js"
import globalConfig, { chinaAppName } from "@/config/config.js"

export function makeApp(cookie, url) {
  const app = import.meta.env.SSR ? createSSRApp(App) : createApp(App)
  const router = createRouter()
  // const langList = ["en", "zh-Hans", "zh-Hant", "ja", "ko", "fr", "de", "es", "it", "pt", "ru"]
  // const langExp = new RegExp(`/(${langList.join("|")})(/|$)`)
  // const match = url.match(langExp);
  // const uselang = match ? match[1] : 'en';
  const uselang = globalConfig.appname == chinaAppName ? "zh-Hans" : hasLangPrefix(url)?.[1] || "en"
  const i18n = createI18nInstance(uselang)
  app.config.globalProperties.$i18n = registerI18n(i18n)

  router.beforeEach((to, from, next) => {
    const langList = ["zh-Hans", "zh-Hant", "ja", "ko", "fr", "de", "es", "it", "pt", "ru"]
    const path = to.path
    const langSegment = path.split("/")[1] // 获取第一个路径段（如 'ja'）
    const isLangRoute = langList.includes(langSegment)

    const exp = new RegExp(`^/(${langList.join("|")})$`)
    if (exp.test(path) && isLangRoute && !path.endsWith("/")) {
      next({
        path: path + "/", // 强制加斜杠
        query: to.query, // 保留查询参数
        hash: to.hash, // 保留 hash
        replace: true, // 替换当前历史记录（避免回退问题）
      })
    } else {
      next() // 正常放行
    }
  })

  const store = createPinia()
  store.$i18n = registerI18n(i18n)
  const head = createHead()
  app.use(i18n)
  app.use(firebaseFuctionInit)
  app.use(store)
  app.use(head)
  app.use(router)
  app.use(fc)
  app.use(vue3GoogleLogin, {
    clientId: "1069642802272-0ktgtg6hn72ljht0bltd9h14qseflsvj.apps.googleusercontent.com",
    scope: "profile email",
  })

  // SSR 场景下初始化 userDataStore 并传递 cookie
  const userDataStore = useUserDataStore()
  if (import.meta.env.SSR) {
    userDataStore.initCookie(cookie || "")
  }

  if (userDataStore.appLanguage != i18n.global.locale) {
    userDataStore.appLanguage = i18n.global.locale
  }

  // const getSentryUrl = () => {
  //   let url = ""
  //   const language = $$language()
  //   if (isDev()) {
  //     if (language === "en") {
  //       url = "https://bb094092630245787fc6089de08dcb8b@sen-as.yinhe.top/7"
  //     } else {
  //       url = "https://806b960185aa65ce7d18071d56a0b739@sen-bj.yinhe.top/4"
  //     }
  //   } else {
  //     if (language === "en") {
  //       url = "https://6f7e9f113eab81487483f81773c1b9be@sen-as.yinhe.top/6"
  //     } else {
  //       url = "https://5e44e697fcf7373ca96a120cd99761e2@sen-bj.yinhe.top/2"
  //     }
  //   }
  //   return url
  // }

  // const setSentryUid = async () => {
  //   const u_id = (await firebaseUtils?.getAnonymousID()) ?? ""
  //   Sentry.setUser({ id: u_id })
  // }

  // if (!import.meta.env.SSR) {
  //   Sentry.init({
  //     app,
  //     dsn: getSentryUrl(),
  //     integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  //     tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //     tracePropagationTargets: [],
  //     replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //     replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  //   })
  //   setSentryUid()
  // }

  return {
    app,
    router,
    store,
    head,
  }
}
